@if (!isInfinite) {
<div class="container">
  <svg width="75" height="75">
    <circle cx="40" cy="40" r="30" [style.strokeDashoffset]="progressValue()" class="progress-circle"></circle>
  </svg>
</div>
} @else {
<div
  class="tw-inline-block tw-h-7 tw-w-7 tw-animate-spin tw-rounded-full tw-border-2 tw-border-solid tw-align-middle tw-motion-reduce:tw-animate-spine"
  [ngClass]="colorClasses()"
></div>
}
